// extracted by mini-css-extract-plugin
export var backupIcon = "_sm-1";
export var image = "_sm-0";